

















































































import Vue from 'vue'
import { WorkStationIotServiceProxy,MachineServiceProxy,
UnbindMachineIotDTO
 } from '@/service-proxies/app-v2/workStation.service-proxies'
import {
  GatewayServiceProxy,
  IotAppPropertyServiceProxy,
  IotAppServiceProxy
} from '@/service-proxies/app-v2/iot-console.service-proxies'

import MachineIotSetting from './iot-setting.vue'

const workStationIotSrvProxy = new WorkStationIotServiceProxy()
const gatewaySrvProxy = new GatewayServiceProxy()
const iotAppSrvProxy = new IotAppServiceProxy()
const iotPropertySrvProxy = new IotAppPropertyServiceProxy()
const machineSrvProxy = new MachineServiceProxy();

export default Vue.extend({
  components: {
    MachineIotSetting
  },
  props: {},
  data() {
    return {
      hasFeature: false,
      gatewayCode: undefined,
      gatewayStatus: undefined,
      hasCollection: false,
      loading: false,
      workStationId: undefined,
      iotInfo: {
        id: undefined,
        code: undefined,
        status: false
      },
      appOpening: false,
      currentAppRunning: true,
      currentAppCode: undefined,
      currentAppId: undefined,
      currentGatewayCode: undefined,
      currentGatewayId: undefined,
      iotAppList: [],
      iotPropertyItemList: []
    }
  },
  computed: {},
  watch:{
    'iotInfo.id':{
      handler(){
        this.$emit('changeIot',this.iotInfo.id)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    show(workStationId) {
      if(!workStationId){
        return
      }
      this.iotInfo={
        id: undefined,
        code: undefined,
        status: false
      };
      this.workStationId = workStationId
      this.loading = true
      workStationIotSrvProxy
        .getIotsByWorkstationId(workStationId)
        .then((workStationIotRes) => {
          // 机床绑定的iot数据
          if (workStationIotRes.length <= 0) {
            return
          }
          const iot = workStationIotRes[0]
          this.iotInfo.id = iot.iotId
          this.iotInfo.code = iot.iotCode
          return gatewaySrvProxy.getGatewayByCode(iot.iotCode)
        })
        .then((iotRes) => {
          // iot的状态
          if (!iotRes) {
            this.iotInfo.id = undefined
            return
          }
          this.iotInfo.status = iotRes.isOnline
          return iotRes.code
        })
        .then((gatewayCodeRes) => {
          // 获取iot驱动应用列表
          if (!gatewayCodeRes) {
            return
          }
          return iotAppSrvProxy.getIotAppList(undefined, gatewayCodeRes, undefined)
        })
        .then((iotAppListRes) => {
          // 默认使用第一个驱动APP
          if (!iotAppListRes) {
            return
          }
          if (iotAppListRes.items.length < 2) {
            return
          }
          return iotAppListRes.items[1]
        })
        .then((iotAppRes) => {
          // 根据第一个非0号驱动获取采集列表
          if (!iotAppRes || !this.iotInfo.code) {
            return
          }
          this.currentAppRunning = iotAppRes.isOnline;
          this.currentAppCode = iotAppRes.code;
          this.currentAppId = iotAppRes.id;
          this.currentGatewayCode = this.iotInfo.code;
          this.currentGatewayId = this.iotInfo.id;
          return iotPropertySrvProxy.getIotAppPropertyListWithNoValue(iotAppRes.code, this.iotInfo.code)
        })
        .then((iotPropertyItemRes) => {
          // 采集列表
          if (!iotPropertyItemRes) {
            return
          }
          this.iotPropertyItemList = iotPropertyItemRes.items
        })
        .finally(() => {
          this.initFeature();
          this.loading = false;
        })
    },
    initFeature(){
      machineSrvProxy.feature(this.workStationId)
        .then(res=>{
          console.log('init feature', res);
          this.hasFeature = res.hasDataCollection || res.hasRemoteConnection;
          this.hasCollection = res.hasDataCollection;
          this.gatewayCode= res.gatewayCode;
          if(!res.gatewayCode){
            throw Error('gateway is undefined');
          }
          return res;
        })
        .then(res=>{
          return gatewaySrvProxy.getGatewayById(res.gatewayId);
        })
        .then(gateway=>{
          this.gatewayStatus=gateway.isOnline;
        })
        .catch(err=>{
          console.log(err);
        });
    },
    refreshIot() {
      this.show(this.workStationId)
    },
    removeIot() {
      if (!this.iotInfo.id || !this.workStationId) {
        return
      }
      const input: UnbindMachineIotDTO=new UnbindMachineIotDTO();
      input.gatewayId = this.iotInfo.id;
      input.machineId = this.workStationId;
      input.featureValue=1;

      machineSrvProxy.unbindIot(input)
        .then((res) => {
          this.$message.success('移除IOT采集功能成功')
          this.$emit('remove', this.iotInfo.id )
          this.iotInfo.id = undefined
          this.iotInfo.code = undefined
          this.iotInfo.status = false

        })
    },
    handlerSetting(){
      this.refreshIot();
    },
    iotSetting() {
      this.$refs.iotSetting.open(
          this.workStationId,
          this.currentGatewayCode,
          this.currentGatewayId,
          this.currentAppCode,
          this.currentAppId);
    },
    openApp(){
      this.appOpening=true
      iotAppSrvProxy.startIotApp(this.currentGatewayCode, this.currentAppCode)
        .then(res=>{
          this.currentAppRunning = true;
          this.$message.success(this.$t('page_ops_machine_collection_enable_success'));
        })
        .finally(()=>{
          this.appOpening= false;
        });
    },
    closeApp(){
      this.$confirm({
        title: this.$t('page_ops_machine_collection_disable_confirm'),
        onOk:()=>{
          iotAppSrvProxy.stopIotApp(this.currentGatewayCode, this.currentAppCode)
              .then(res=>{
                this.currentAppRunning = false;
                this.$message.success(this.$t('page_ops_machine_collection_disable_success'));
              });
        }
      })
    }
  }
})
